import "bootstrap/dist/css/bootstrap.min.css";
import * as OFMSUI from "react-bootstrap";
import React, {  useState } from "react";
import HousingService from "../../../Services/HousingService";
import {FaWallet, FaBalanceScale, FaClipboard, FaRupeeSign, FaRegCreditCard, FaMoneyBill, FaBriefcase } from "react-icons/fa";


const ClassificationHeads = () => {
    const [budgetdata, saveBudgetData] = useState([]);

    React.useEffect(() => {
        HousingService.ClassificationBudget().then((res) => {
            saveBudgetData(res.data)
            console.log(res.data);
        });
    }, [])

    return (
        <>
            <OFMSUI.Row
                className="row card-row px-1"
                style={{ display: "flex", flexWrap: "nowrap", overflowX: "auto", gap: "4px" }}
            >
                {[
                    {
                        title: "Regular",
                        keys: ["budget", "expen"],
                        className: "first-dashboard",
                        classification: "01",
                        icon: <FaWallet size={24} style={{ color: "#007bff" }} />,
                        tooltip: `20101-SALARIES TO STAFF
20104-MEDICAL ALLOWNACE
20106-CONVEYANCE ALLOWNACE
20107-EX-GRATIA
20108-WAGES TO NMR
20110-HONORARIUM TO CHAIRMAN AND DIRECTOR
20112-REMMUNERATION TO OUTSOURCING STAFF
20501-EDUCATIONAL ALLOWANCE
20502-LEAVE SALARY CONTRIBUTION
20503-PENSION AND CONTRIBUTION
20504-AWARDS AND INCENTIVES
20508-LIVERY TO STAFF
20623-SECURITY CHARGES
21301-EMPLOYER EPF CONTRIBUTION
21303-ADMIN CHARGES ON EPF/FPF
21304-EDLIS CHARGES
21305-ADMIN CHARGES ON EDLIS
20401-GRATUITY`,
                    },
                    {
                        title: "Conveyance",
                        keys: ["budget", "expen"],
                        className: "second-dashboard",
                        classification: "02",
                        icon: <FaClipboard size={24} style={{ color: "#FF6F00" }} />,
                        tooltip: `20605-INSURANCE-VEHICLES
20620-HIRE CHARGES -VEHICLES
20634-POL CHARGES
20635-REPAIRS AND MAINTENANCE-VEHICLES`,
                    },
                    {
                        title: "Administrative Expen.",
                        keys: ["budget", "expen"],
                        className: "third-dashboard",
                        classification: "03",
                        icon: <FaBalanceScale size={24} style={{ color: "#4CAF50" }} />,
                        tooltip: `20203-GODOWN RENT
20204-TRANSPORTATION CHARGES
20505-LTC TO STAFF
20601-RENT
20602-RATES AND TAXES
20603-WATER CHARGES
20606-ELECTRICITY CHARGES
20607-PRINTING AND STATIONARY
20608-POSTAGE
20609-TELEGRAMS
20610-TELEPHONES
20611-INTERNET CHARGES
20612-TRAVELLING EXPENSES-STAFF
20615-ADVERTISEMENT CHARGERS
20618-LEGAL CHARGERS
20621-RECRUITMENT AND TRAINING COST
20642-AUDIT FEE
20645-INAUGURAL EXPENSES`,
                    },
                    {
                        title: "Capital Exp.",
                        keys: ["budget", "expen"],
                        className: "second-dashboard",
                        classification: "04",
                        icon: <FaMoneyBill size={24} style={{ color: "#FF6F00" }} />,
                        tooltip: `40101-LAND
40102-BUILDINGS
40103-PLANT AND MACHINERY
40104-OFFICE AND OTHER EQUIPMENT
40105-FURNTITURE AND FIXTURES
40106-ELECTRICAL EQUIPMENT
40107-VEHICLES
40109-BICYCLES
40110-COMPUTERS`,
                    },
                    {
                        title: "Others",
                        keys: ["budget", "expen"],
                        className: "first-dashboard",
                        classification: "05",
                        icon: <FaRegCreditCard size={24} style={{ color: "#007bff" }} />,
                        tooltip: `20206-INSTITUTIONAL CHARGES-ZMS
20207-INSTITUTIONAL CHARGES-VOS/SHGS
20208-SERVICE CHARGES TO SERVICE PROVIDERS
20599-OTHER CONTRIBUTION
20622-DONATIONS
20637-PROFESSIONAL CHARGES
20639-SOFTWARE DEVELOPMENT CHARGES
20646-COLOURING EXPENSES
20699-MISCELLANEOUS EXPENDITURE`,

                    },

                    {
                        title: "Advance to staff",
                        keys: ["budget", "expen"],
                        className: "third-dashboard",
                        classification: "07",
                        icon: <FaBriefcase size={24} style={{ color: "#4CAF50" }} />,
                        tooltip: `41001_FESTIVAL ADAVNCE
41002-EDUCATIONAL ADVANCE
41003-CYCLE-ADVANCE
41004-MOTOR CAR / CYCLE ADAVANCE
41005-HOUSE BUILDING ADVANCE'
41006-TOUR ADVANCE
41007-L.T.C ADVANCE
41008-SALARY ADAVANCE
41009-MISC STAFF ADVANCE
41010-SPECIAL FESTIVAL ADVANCE
41011-MARRAIAGE ADVANCE
41013-MEDICAL ADVANCE
41014-COMPUTER ADVANCE`,
                    },
                    {
                        title: "Recoveries/Liabilities",
                        keys: ["budget", "expen"],
                        className: "third-dashboard",
                        classification: "08",
                        icon: <FaRupeeSign size={24} style={{ color: "#4CAF50" }} />,
                        tooltip: `31301 - OTHER LIABILITIES
31701 - SALARIES PAYABLE 
31702 - REMUNERATION TO OUTSOURCING STAFF PAYABLE 
31703 - WAGES TO NMR PAYABLE 
34401 - GPF PAYABLE 3
4402 - GPF LOAN PAYABLE 
34403 - APGLI PAYABLE 
34405 - GIC PAYABLE 
34406 - EPF PAYABLE 
34412 - LIC PAYABLE 
34414 - POSTAL SAVINGS PAYABLE 
34415 - PROFESSIONAL TAX PAYABLE 
34416 - DEDUCTIONS - OTHER AGENCIES PAYABLE 
34417 - CMS RELEF FUND PAYABLE 
34419 - HCESA PAYABLE 
34420 - STAFF PERSONAL LOANS PAYABLE 
34424 - EMPLOYEES RELEIF FUND PAYABLE 
34425 - APSG EMPLOYEES WELFARE FUND PAYABLE 
34426 - GSLI PAYABLE 
34428 - CTD RECOVERIES PAYABLE 
34429 - ARMY WELFARE FUND PAYABLE 
34431 - FLAG DAY FUND PAYABLE 
34432 - PMS RELEIF FUND PAYABLE`,
                    },
                ].map((item, index) => {
                    const filteredData = budgetdata.filter((d) => d.classification === item.classification);

                    return (
                        <OFMSUI.Col
                            key={index}
                            xs={12}
                            sm={12}
                            md={1}
                            lg={1}
                            xl={1}
                            className={`${item.className} mx-1 mb-3`}
                            aria-label={item.title}
                            style={{ flex: "0 0 auto", minWidth: "220px" }}
                        >
                            <div
                                className="dashboard-card p-2 d-flex align-items-center"
                                style={{
                                    border: "1px solid #ccc",
                                    borderRadius: "6px",
                                    backgroundColor: "#f9f9f9",
                                    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                                    transition: "transform 0.2s ease",
                                }}
                                onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.03)")}
                                onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
                                title={item.tooltip ? item.tooltip : ""} // Ensure tooltip appears for all cards with a tooltip
                            >
                                <div className="item-dash-board">
                                    <p className="text-start fw-bold" style={{ fontSize: "0.8rem" }}>
                                        {item.title}
                                    </p>
                                    <div>
                                        <h3
                                            className="text-number"
                                            style={{ fontSize: "0.8rem", color: "#4E342E", fontWeight: "bold" }}
                                        >
                                            Budget:{" "}
                                            {filteredData.length > 0
                                                ? filteredData
                                                    .reduce((a, v) => a + parseFloat(v[item.keys[0]] || 0), 0)
                                                    .toFixed(2)
                                                : "0.00"}
                                        </h3>
                                        <p style={{ fontSize: "0.8rem", color: "green", fontWeight: "bold" }}>
                                            Expenditure:{" "}
                                            {filteredData.length > 0
                                                ? filteredData
                                                    .reduce((a, v) => a + parseFloat(v[item.keys[1]] || 0), 0)
                                                    .toFixed(2)
                                                : "0.00"}
                                        </p>
                                    </div>
                                </div>
                                <div className="icon m-auto">{item.icon}</div>
                            </div>
                        </OFMSUI.Col>
                    );
                })}
            </OFMSUI.Row>
        </>
    )
}

export default ClassificationHeads
